import React from 'react'
import PropTypes from 'prop-types'
import { NavLink, withRouter } from 'react-router-dom'
import { Field, Form } from 'redux-form'
import { asyncValidate, shouldAsyncValidate } from "redux-form-yup"
import withForm from 'with/Form'

import TextField from 'components/TextField'
import Button from 'components/buttons/Button'

import schema from './schema'
import styles from './index.css'

@withForm({
  asyncValidate : asyncValidate(schema),
  shouldAsyncValidate
})
export default class extends React.Component {
  
  static propTypes = {
    form     : PropTypes.string.isRequired,
    onSubmit : PropTypes.func.isRequired,
  }

  constructor(props) {
    super(props)
  }

  render() {
    const { handleSubmit } = this.props
    return (
      <Form onSubmit={handleSubmit}>
        <h1>Reset Password</h1>
        <Field 
          name='newPassword' 
          label='New Password'
          type='password'
          component={TextField} 
          />
        <Field 
          name='confirmPassword' 
          label='Confirm Password'
          type='password'
          component={TextField} 
          />
        <br/><br/>
        <Button 
          loading={this.props.submitting}
          type='submit'
          color='orange' 
          style={{margin: '2rem 0rem'}}>
          Set Password
        </Button>
      </Form>
    )
  }

}



// WEBPACK FOOTER //
// ./src/forms/ResetPassword/index.jsx